var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V4.13333C2 3.3866 2 3.01323 2.14532 2.72801C2.27316 2.47713 2.47713 2.27316 2.72801 2.14532C3.01323 2 3.3866 2 4.13333 2H7.86667C8.6134 2 8.98677 2 9.27199 2.14532C9.52287 2.27316 9.72684 2.47713 9.85468 2.72801C10 3.01323 10 3.3866 10 4.13333V6.66667M14 14H14.0067M5.33333 4H6.66667M11.3333 14C11.3333 12.5272 12.5272 11.3333 14 11.3333M8.66667 14C8.66667 11.0545 11.0545 8.66667 14 8.66667",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.8234d9b80eb8c56a19943c526466be4f.svg";
export { ForwardRef as ReactComponent };